var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.64,
    height: 17.349,
    viewBox: "0 0 19.64 17.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82,17.349a1.156,1.156,0,0,1-.759-.283c-.793-.689-1.558-1.336-2.233-1.907l0,0a41.415,41.415,0,0,1-4.876-4.544A7.23,7.23,0,0,1,0,5.86,6.07,6.07,0,0,1,1.558,1.7,5.3,5.3,0,0,1,5.487,0,4.963,4.963,0,0,1,8.572,1.058,6.288,6.288,0,0,1,9.82,2.351a6.289,6.289,0,0,1,1.248-1.293A4.963,4.963,0,0,1,14.153,0a5.3,5.3,0,0,1,3.929,1.7A6.07,6.07,0,0,1,19.64,5.86a7.23,7.23,0,0,1-1.948,4.751,41.406,41.406,0,0,1-4.876,4.544c-.676.572-1.442,1.22-2.237,1.911A1.157,1.157,0,0,1,9.82,17.349ZM5.487,1.142A4.157,4.157,0,0,0,2.4,2.472,4.937,4.937,0,0,0,1.15,5.86,6.084,6.084,0,0,0,2.834,9.883a40.755,40.755,0,0,0,4.736,4.4l0,0c.677.573,1.445,1.223,2.245,1.917.8-.7,1.573-1.346,2.252-1.92a40.762,40.762,0,0,0,4.736-4.4A6.085,6.085,0,0,0,18.489,5.86a4.937,4.937,0,0,0-1.253-3.388,4.157,4.157,0,0,0-3.083-1.33,3.833,3.833,0,0,0-2.382.819,5.554,5.554,0,0,0-1.328,1.525.729.729,0,0,1-1.248,0A5.549,5.549,0,0,0,7.869,1.961,3.833,3.833,0,0,0,5.487,1.142Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.e212db64ab79bbe3a10b935eb8c38463.svg";
export { ForwardRef as ReactComponent };